import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'
import { TiktokCampaign } from 'src/Types/campaigns'
import { MILLISECONDS_IN_SECONDS } from 'src/Constants/numeric'
import { getClientId, getGaSession } from 'src/Redux/analyticsApi/helpers'

export interface AddNewTikTokCampaignBody {
  trackUrl: string
  trackTiktokId: string
  trackTitle: string
  trackPlayUrl: string
  trackCoverUrl: string
  trackAuthorName: string
  initialVideoCount: number
  trackDuration: number
}

const createNewCampaignApi = rtkApi.injectEndpoints({
  endpoints(build) {
    return {
      createNewTiktokCampaign: build.mutation<
        TiktokCampaign,
        AddNewTikTokCampaignBody
      >({
        query: (body) => ({
          url: `${APP.TIKTOK_SERVER}/artist/tiktok/campaigns`,
          method: 'POST',
          headers: {
            'x-scga-session': getGaSession(),
            'x-scga-client-id': getClientId(),
            'x-scga-timestamp': String(Date.now() * MILLISECONDS_IN_SECONDS),
            'x-scga-page-title': window.location.origin,
          },
          body: {
            ...body,
            languages: [],
            genres: [],
            isDanceRequested: false,
          },
        }),
      }),
    }
  },
})

export const { useCreateNewTiktokCampaignMutation } = createNewCampaignApi
